import React from 'react';
import { PerfectDayPage } from './pages/PerfectDayPage';
export function App() {
  return <PerfectDayPage data-id="element-0" data-mp="35ckaa75id2iz" />;
}